import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { useParallax } from "../useParallax";

export default function CareMomentsAnimatedPlus(props: {
  scrollRef: React.RefObject<HTMLElement>;
}) {
  const svgRef = React.useRef(null);

  useParallax({
    container: props.scrollRef,
    target: svgRef,
    factor: 0.05,
  });

  return (
    <AnimatedPlusSVG
      ref={svgRef}
      className="AnimatedPlus"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="plus-clip" className="plus-clip">
          <path
            d="M26.2876 64.4885C24.9833 64.4885 23.7335 63.9867 22.8113 63.094C21.8892 62.2005 21.3719 60.9896 21.3719 59.726V48.2777C21.3719 46.7543 20.7466 45.2928 19.6349 44.2157C18.5228 43.1386 17.0145 42.5328 15.4419 42.5328H4.91568C4.26988 42.5342 3.63026 42.4111 3.0334 42.1726C2.43661 41.9334 1.89427 41.5826 1.43761 41.1402C0.981014 40.6978 0.618905 40.1723 0.372241 39.5941C0.125573 39.0159 -0.000948785 38.3962 5.35661e-06 37.7705V26.1597C5.35661e-06 24.8959 0.517728 23.6838 1.43936 22.7895C2.361 21.8953 3.6113 21.3919 4.91568 21.39H15.4419C16.2202 21.391 16.9911 21.2433 17.7105 20.9553C18.4299 20.6673 19.0836 20.2449 19.6341 19.712C20.1852 19.1791 20.6217 18.5463 20.92 17.8496C21.2183 17.1531 21.3719 16.4064 21.3719 15.6523V4.76963C21.3719 3.50589 21.8892 2.29376 22.8106 1.39949C23.7327 0.505223 24.9826 0.0018505 26.2876 0H38.2718C39.5768 0 40.8296 0.50252 41.7525 1.397C42.6761 2.29149 43.1948 3.50461 43.1948 4.76963V15.6523C43.1948 17.174 43.8187 18.6334 44.9289 19.7094C46.0399 20.7855 47.5462 21.39 49.1172 21.39H59.077C60.3819 21.39 61.6347 21.8926 62.5576 22.7871C63.4813 23.6815 64 24.8947 64 26.1597V37.7705C64 38.3965 63.8721 39.0164 63.6245 39.5946C63.3769 40.173 63.0147 40.6983 62.5576 41.1406C62.0999 41.5829 61.5576 41.9334 60.9602 42.1726C60.3628 42.4118 59.7228 42.5342 59.077 42.5328H49.1172C47.5455 42.5349 46.0392 43.1407 44.9289 44.2178C43.8179 45.2956 43.1948 46.7557 43.1948 48.2777V59.726C43.1948 60.3525 43.067 60.9718 42.8194 61.5506C42.5718 62.1286 42.2095 62.654 41.7525 63.0961C41.2947 63.5389 40.7524 63.8891 40.1551 64.1283C39.5577 64.3675 38.9177 64.49 38.2718 64.4885H26.2876Z"
            fill="white"
          />
        </clipPath>
        <pattern id="imagePattern" patternUnits="userSpaceOnUse" width="200%" height="200%">
          <g style={{ transform: "translateX(-32px) translateY(-32px)" }}>
            <image href="/assets/abstract-folds-wallpaper.jpg" width="200%" height="200%" />
          </g>
        </pattern>
      </defs>
      <rect width={64} height={64} clipPath="url(#plus-clip)" fill="url(#imagePattern)" />
    </AnimatedPlusSVG>
  );
}

const imageInKeyframes = keyframes`
      from {
          scale: 1;
          rotate: -40deg;
          transform: translateY(-30%);
      }
  `;

const inKeyframes = keyframes`
      from {
          scale: 0.2;
          filter: blur(30px);
          opacity: 0;
          rotate: 360deg;
      }
  `;

const clipInKeyframes = keyframes`
      from {
          scale: 0;
      }
  `;

const patternInKeyframes = keyframes`
      from {
          scale: 0.7;
      }
  `;

const AnimatedPlusSVG = styled.svg`
  --size: 40%;
  width: var(--size);
  height: var(--size);
  animation: ${inKeyframes} 3s ease backwards;

  clipPath {
    transform: rotate(0deg);
    animation: ${clipInKeyframes} 6s ease backwards;
    transform-origin: center center;
  }

  pattern {
    margin-left: -64px;
    margin-top: -64px;
    animation: ${patternInKeyframes} 5s ease backwards;
  }

  image {
    background-image: url(/assets/abstract-folds-wallpaper.jpg);
    scale: 2;
    animation: ${imageInKeyframes} 30s linear backwards alternate-reverse infinite;
    transform-origin: center center;
    transform: translateY(var(--parallax-translate-y));
  }
`;
